// src/App/Controllers/Accounting/Services/ArReport.js
// import dayjs from 'dayjs';

// const randomNames = [
//   'Alpha Traders',
//   'Beta Distributors',
//   'Gamma Enterprises',
//   'Delta Supplies',
//   'Epsilon Corp',
//   'Zeta Imports',
//   'Theta Wholesalers',
//   'Omega Retailers',
//   'Sigma Pvt Ltd',
//   'Nova Industrial',
//   'Apex Solutions',
//   'Vertex Commercials',
// ];

// export const get_ar_report = async ({ branch, from, to }) => {
//   // Generate mock data
//   const generateFakeCustomer = (i) => {
//     const age_0_30 = Math.floor(Math.random() * 5000);
//     const age_31_60 = Math.floor(Math.random() * 4000);
//     const age_61_90 = Math.floor(Math.random() * 3000);
//     const age_90_plus = Math.floor(Math.random() * 2000);

//     return {
//       customer_id: `cus_${i + 1}`,
//       customer_name: randomNames[i % randomNames.length], // Random name instead of "Customer ${i+1}"
//       total_receivable: age_0_30 + age_31_60 + age_61_90 + age_90_plus,
//       age_0_30,
//       age_31_60,
//       age_61_90,
//       age_90_plus,
//     };
//   };

//   const fakeData = Array.from({ length: 12 }, (_, i) => generateFakeCustomer(i));

//   // Simulate a short network delay
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(fakeData);
//     }, 300);
//   });
// };


//New UI services for AR Report
// src/App/Controllers/Accounting/Services/ArReport.js
// import dayjs from 'dayjs';

// const customerNames = [
//   'Alpha Traders', 'Beta Distributors', 'Gamma Enterprises',
//   'Delta Supplies', 'Epsilon Corp', 'Zeta Imports',
//   'Theta Wholesalers', 'Omega Retailers', 'Sigma Pvt Ltd',
//   'Nova Industrial', 'Apex Solutions', 'Vertex Commercials'
// ];

// const contactNames = [
//   'Alex Johnson', 'Maria Garcia', 'James Wilson',
//   'Sarah Davis', 'Robert Brown', 'Jennifer Miller',
//   'Thomas Moore', 'Emily Taylor', 'Christopher Anderson',
//   'Jessica Thomas', 'David Jackson', 'Elizabeth White'
// ];

// const domains = ['gmail.com', 'yahoo.com', 'outlook.com', 'company.com', 'business.com'];

// export const get_ar_report = async ({ branch, customerType, status, from, to }) => {
//   // Generate mock data for customers
//   const generateFakeCustomer = (i) => {
//     const age_0_30 = Math.random() * 5000;
//     const age_31_60 = Math.random() * 4000;
//     const age_61_90 = Math.random() * 3000;
//     const age_90_plus = Math.random() * 2000;
    
//     const customerTypes = ['retail', 'wholesale', 'corporate', 'government'];
//     const statuses = ['current', 'overdue', 'paid', 'disputed'];
//     const paymentTerms = ['Net 30', 'Net 60', 'Due on Receipt', 'Net 15'];
    
//     const customerTypeVal = customerType !== 'all' ? customerType : customerTypes[Math.floor(Math.random() * customerTypes.length)];
//     const statusVal = status !== 'all' ? status : statuses[Math.floor(Math.random() * statuses.length)];
    
//     // Generate contact info
//     const contactName = contactNames[i % contactNames.length];
//     const emailUser = contactName.toLowerCase().replace(' ', '.');
//     const domain = domains[Math.floor(Math.random() * domains.length)];
    
//     // Calculate due date (30-90 days in past or future)
//     const dueDateOffset = (statusVal === 'overdue' ? -1 : 1) * (30 + Math.floor(Math.random() * 60));
    
//     return {
//       customer_id: `cus_${i + 1}`,
//       customer_name: customerNames[i % customerNames.length],
//       customer_type: customerTypeVal,
//       total_receivable: age_0_30 + age_31_60 + age_61_90 + age_90_plus,
//       age_0_30,
//       age_31_60,
//       age_61_90,
//       age_90_plus,
//       payment_terms: paymentTerms[Math.floor(Math.random() * paymentTerms.length)],
//       status: statusVal,
//       due_date: dayjs().add(dueDateOffset, 'days').format('YYYY-MM-DD'),
//       contact_name: contactName,
//       contact_email: `${emailUser}@${domain}`,
//       contact_phone: `+1 (555) ${Math.floor(100 + Math.random() * 900)}-${Math.floor(1000 + Math.random() * 9000)}`,
//     };
//   };

//   // Filter based on parameters
//   const fakeData = Array.from({ length: 24 }, (_, i) => generateFakeCustomer(i))
//     .filter(item => {
//       return (branch === 'all' || item.branch === branch) &&
//              (customerType === 'all' || item.customer_type === customerType) &&
//              (status === 'all' || item.status === status);
//     });

//   // Simulate network delay
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(fakeData);
//     }, 500);
//   });
// };


// src/App/Controllers/Accounting/Services/ArReport.js
import axios from 'axios';
import APIURL from "../../../Main/apiurl";

const getAuthToken = () => localStorage.getItem("user");

const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : null;
};



export const get_ar_report = async ({ branch, customerType, status, from, to }) => {
  try {
    const headers = getAuthHeaders();
    
    if (!headers) {
      throw new Error('Missing authentication token');
    }

    const params = {
      branch: branch || 'all',
      customerType: customerType || 'all',
      status: status || 'all',
      from,
      to
    };

    const response = await axios.get(`${APIURL}/ar-report`, {
      params,
      headers
    });

    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Failed to fetch AR report');
    }
  } catch (error) {
    console.error('AR Report API Error:', error);
    
    console.warn('Using mock data due to API error');
    return await getMockARReport({ branch, customerType, status, from, to });
  }
};

const getMockARReport = async ({ branch, customerType, status, from, to }) => {
  const customerNames = [
    'Alpha Traders', 'Beta Distributors', 'Gamma Enterprises',
    'Delta Supplies', 'Epsilon Corp', 'Zeta Imports',
    'Theta Wholesalers', 'Omega Retailers', 'Sigma Pvt Ltd',
    'Nova Industrial', 'Apex Solutions', 'Vertex Commercials'
  ];

  const contactNames = [
    'Alex Johnson', 'Maria Garcia', 'James Wilson',
    'Sarah Davis', 'Robert Brown', 'Jennifer Miller',
    'Thomas Moore', 'Emily Taylor', 'Christopher Anderson',
    'Jessica Thomas', 'David Jackson', 'Elizabeth White'
  ];

  const domains = ['gmail.com', 'yahoo.com', 'outlook.com', 'company.com', 'business.com'];

  const generateFakeCustomer = (i) => {
    const age_0_30 = Math.random() * 5000;
    const age_31_60 = Math.random() * 4000;
    const age_61_90 = Math.random() * 3000;
    const age_90_plus = Math.random() * 2000;
    
    const customerTypes = ['retail', 'wholesale', 'corporate', 'government'];
    const statuses = ['current', 'overdue', 'paid', 'disputed'];
    const paymentTerms = ['Net 30', 'Net 60', 'Due on Receipt', 'Net 15'];
    
    const customerTypeVal = customerType !== 'all' ? customerType : customerTypes[Math.floor(Math.random() * customerTypes.length)];
    const statusVal = status !== 'all' ? status : statuses[Math.floor(Math.random() * statuses.length)];
    
    const contactName = contactNames[i % contactNames.length];
    const emailUser = contactName.toLowerCase().replace(' ', '.');
    const domain = domains[Math.floor(Math.random() * domains.length)];
    
    const dueDateOffset = (statusVal === 'overdue' ? -1 : 1) * (30 + Math.floor(Math.random() * 60));
    
    return {
      customer_id: `cus_${i + 1}`,
      customer_name: customerNames[i % customerNames.length],
      customer_type: customerTypeVal,
      total_receivable: age_0_30 + age_31_60 + age_61_90 + age_90_plus,
      age_0_30,
      age_31_60,
      age_61_90,
      age_90_plus,
      payment_terms: paymentTerms[Math.floor(Math.random() * paymentTerms.length)],
      status: statusVal,
      due_date: new Date(Date.now() + dueDateOffset * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      contact_name: contactName,
      contact_email: `${emailUser}@${domain}`,
      contact_phone: `+1 (555) ${Math.floor(100 + Math.random() * 900)}-${Math.floor(1000 + Math.random() * 9000)}`,
    };
  };

  const fakeData = Array.from({ length: 24 }, (_, i) => generateFakeCustomer(i))
    .filter(item => {
      return (branch === 'all' || item.branch === branch) &&
             (customerType === 'all' || item.customer_type === customerType) &&
             (status === 'all' || item.status === status);
    });

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(fakeData);
    }, 500);
  });
};